export default __webpack_public_path__ + "static/media/web-development-banner.f18cc051.svg";